/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { InfectedDateSize } from '../models/InfectedDateSize';

export class InfectedDataOverTime {
  /**
  * Infected data over time
  */
  'infectedDates': Array<InfectedDateSize>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "infectedDates",
      "baseName": "infectedDates",
      "type": "Array<InfectedDateSize>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return InfectedDataOverTime.attributeTypeMap;
  }

  public constructor() {
  }
}

